var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchShortHandle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5028 28L22.5988 22.2M25.7883 14.6667C25.7883 20.5577 20.927 25.3333 14.9303 25.3333C8.93357 25.3333 4.07227 20.5577 4.07227 14.6667C4.07227 8.77563 8.93357 4 14.9303 4C20.927 4 25.7883 8.77563 25.7883 14.6667Z",
    stroke: "#4F2D7F",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5028 28L22.5988 22.2M25.7883 14.6667C25.7883 20.5577 20.927 25.3333 14.9303 25.3333C8.93357 25.3333 4.07227 20.5577 4.07227 14.6667C4.07227 8.77563 8.93357 4 14.9303 4C20.927 4 25.7883 8.77563 25.7883 14.6667Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchShortHandle);
export default __webpack_public_path__ + "static/media/search-short-handle.322b9384df2a9b15cc0d384ceeb75920.svg";
export { ForwardRef as ReactComponent };